import { isArray } from 'lodash-es';

const ensureIsArray = <T>(val: T | T[]): T[] => (isArray(val) ? val : [val]);

export default ensureIsArray;
